
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { PreviewAuditLogsComponent } from './preview-audit-logs/preview-audit-logs.component';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.scss']
})
export class AuditLogsComponent implements OnInit {

  subSearchRecords: SubscriptionLike;
  subGetData: SubscriptionLike;
  operations;
  maxDate:Date = new Date();
  minDate:Date = new Date();
  currentDate : Date = new Date(); 
  tempoperation;
  selectedRow;
  IsAdvanceSearch: boolean = true;
  gridApi: GridApi;
  rowData: any = [];
  columnDefs: any;
  AuditLogForm: UntypedFormGroup;
  action: Subject<any> = new Subject();
  log_data: any;
  OrgUsersList: any[];
  ApplicationIdsList: any[];
  filteredApplicationIds: any[];
  ScreenNamesList: any[];
  auditLogSearch = new IEGAuditLogSearch();
  clonedauditLogSearch: IEGAuditLogSearch = {
    StartDateO: new DateObject,
    EndDateO: new DateObject
  };
  SubCategoryList: Array<any> = [];
  GrandTypeList: Array<any> = [];
  IsGrandType: boolean = false;
  IsOnlyGrandType: boolean = false;
  dataIEGDLL=new IEGDLLData();

  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();

  @Input() screencode: string;
  public ModuleID: string;
  //SDates: any;
  //EDates: any;

  constructor(public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public apiService: ApidataRequestService,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.IsAdvanceSearch = true;
    this.ModuleID = this.screencode;
    this.gridHeaderandActionSettings(this.ModuleID);    
    this.AuditLogFormControls();
    if(this.screencode=="grants")
    {
      this.IsGrandType=true;
      this.IsOnlyGrandType= false;
      this.GetGrantTypeScreenNameList(this.ModuleID);
    }
    else
    {
      this.GrandTypeList =[];
      this.IsGrandType = false;
      this.IsOnlyGrandType= false;
      this.GetScreenNameList(this.ModuleID);
    }
    this.GetApplicationIdsList(this.ModuleID);
    this.GetOrgUsersList();
  }

  toggleCase() {
    this.IsAdvanceSearch = !this.IsAdvanceSearch;
  }

  AuditLogFormControls() {
    this.AuditLogForm = new UntypedFormGroup({
      GrantType:new UntypedFormControl(""),
      ApplicationID: new UntypedFormControl(""),
      ScreenName: new UntypedFormControl("", [Validators.required]),
      UserName: new UntypedFormControl("", [Validators.required]),
      StartDate: new UntypedFormControl(null, [Validators.required]),
      EndDate: new UntypedFormControl(null, [Validators.required])
    })
  }

  SubCategories(ModuleID) {
    this.SubCategoryList = [];
    if (ModuleID == "ist") {
      this.SubCategoryList.push(
        { Subname: 'Activities and Seminars' },
        { Subname: 'Amendments' },
        { Subname: 'Concept Proposal' },
        { Subname: 'General Information' },
        { Subname: 'Institutional Review Board' },
        { Subname: 'Milestones' },
        { Subname: 'Organization Setup' },
        { Subname: 'Publications' },
        { Subname: 'Requests' },
        { Subname: 'Site Evaluation' },
        { Subname: 'Study Reports' },
        { Subname: 'Study Team' }
      );
    }
  }

  gridHeaderandActionSettings(MdID:string) {
    if(MdID=="grants")
    {
    this.columnDefs = [
      { headerName: "Revision", headerTooltip: "Revision", field: 'Revision_num', sortable: false, tooltipField: "Revision_num" },
      { headerName: "Change Description", headerTooltip: "Change Description", field: 'Change_description', sortable: false, tooltipField: "Change_description" },
      { headerName: "Application ID", headerTooltip: "Application ID", field: 'ApplicationCode', sortable: false, tooltipField: "ApplicationCode" },
      { headerName: "Grant Type", headerTooltip: "Grant Type", field: 'GrantType', sortable: false, tooltipField: "GrantType" },
      { headerName: "Screen name", headerTooltip: "Screen name", field: 'ScreenName', sortable: false, tooltipField: "ScreenName" },
      { headerName: "Username", headerTooltip: "Username", field: 'Username', sortable: false, tooltipField: "Username" },
      { headerName: "Changed on Date and Time", headerTooltip: "Changed on Date and Time", field: 'Last_modified_date', sortable: false, tooltipField: "Last_modified_date" }
    ];
  }
  else
  {
    this.columnDefs = [
      { headerName: "Revision", headerTooltip: "Revision", field: 'Revision_num', sortable: false, tooltipField: "Revision_num" },
      { headerName: "Change Description", headerTooltip: "Change Description", field: 'Change_description', sortable: false, tooltipField: "Change_description" },
      { headerName: "Application ID", headerTooltip: "Application ID", field: 'ApplicationCode', sortable: false, tooltipField: "ApplicationCode" },
      { headerName: "Screen name", headerTooltip: "Screen name", field: 'ScreenName', sortable: false, tooltipField: "ScreenName" },
      { headerName: "Username", headerTooltip: "Username", field: 'Username', sortable: false, tooltipField: "Username" },
      { headerName: "Changed on Date and Time", headerTooltip: "Changed on Date and Time", field: 'Last_modified_date', sortable: false, tooltipField: "Last_modified_date" }
    ];
  }
    this.tempoperation = [];
    this.tempoperation.push({
      "name": "View",
      "id": "View"
    });
    this.operations = this.tempoperation.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }
  GetOrgUsersList() {

    this.subGetData = this.apiService.getData("api/IEGAuditActivityLogs/GetAllOrgUsersList?ModuleName=" + this.ModuleID).subscribe(
      (res) => {
        if (res["Status"]) {
          this.OrgUsersList = res["Data"];
        } else {
          this.OrgUsersList = [];
        }
      },

      (err) => {
       // console.error(err);
      }
    );
  }

  GetGrantTypeScreenNameList(ModuleID: string) {
    this.subGetData = this.apiService.getData("api/IEGAuditActivityLogs/GetGrantTypes?ModuleName=" + this.ModuleID).subscribe(
      (res) => {
        if (res["Status"]) {
          this.dataIEGDLL= res["Data"];
          this.GrandTypeList =[];
          this.ScreenNamesList =[];
          this.GrandTypeList =  this.dataIEGDLL.GrantDropDownData;
          if(this.GrandTypeList.length>1)
          {
          this.IsOnlyGrandType= false;
          this.AuditLogForm.controls["GrantType"].setValue("All");
          }
        else
        {
           this.IsOnlyGrandType= true;
           this.AuditLogForm.controls["GrantType"].setValue(this.GrandTypeList[0].value);
        }
          this.ScreenNamesList = this.dataIEGDLL.lstPros;
          this.ScreenNamesList.push({ label: "Documents", value: "Documents" });
          this.ScreenNamesList.push({ label: "Attachments", value: "Attachments" });
          this.ScreenNamesList.push({ label: "FAQ", value: "FAQ" });
          this.ScreenNamesList.push({ label: "Notes", value: "Notes" });
          this.ScreenNamesList.push({ label: "RFI", value: "RFI" });
          this.ScreenNamesList.push({ label: "Review Details", value: "Review_Details" });

        } else {
          this.ScreenNamesList = [];
          this.GrandTypeList =[];
          this.IsOnlyGrandType= false;
        }
      },

      (err) => {
       // console.error(err);
      }
    );
  }

  GetScreenNameList(ModuleID: string) {
    this.subGetData = this.apiService.getData("api/IEGAuditActivityLogs/GetScreenNameList?ModuleName=" + this.ModuleID).subscribe(
      (res) => {
        if (res["Status"]) {
          this.ScreenNamesList = res["Data"];
          this.ScreenNamesList.push({ label: "Documents", value: "Documents" });
          this.ScreenNamesList.push({ label: "Attachments", value: "Attachments" });
          this.ScreenNamesList.push({ label: "FAQ", value: "FAQ" });
          this.ScreenNamesList.push({ label: "Notes", value: "Notes" });
          this.ScreenNamesList.push({ label: "RFI", value: "RFI" });
          this.ScreenNamesList.push({ label: "Review Details", value: "Review_Details" });

        } else {
          this.ScreenNamesList = [];
        }
      },

      (err) => {
       // console.error(err);
      }
    );
  }

  OnGrandTypeChange(event)
  {
     ;
    if (event.value != "") {
    this.subGetData = this.apiService.getData("api/IEGAuditActivityLogs/GetGrantTypeScreenNameList?ModuleName=" + this.ModuleID+ '&GrantType=' + event.value).subscribe(
      (res) => {
        if (res["Status"]) {
          this.ScreenNamesList = res["Data"];
          this.ScreenNamesList.push({ label: "Documents", value: "Documents" });
          this.ScreenNamesList.push({ label: "Attachments", value: "Attachments" });
          this.ScreenNamesList.push({ label: "FAQ", value: "FAQ" });
          this.ScreenNamesList.push({ label: "Notes", value: "Notes" });
          this.ScreenNamesList.push({ label: "RFI", value: "RFI" });
          this.ScreenNamesList.push({ label: "Review Details", value: "Review_Details" });

        } else {
          this.ScreenNamesList = [];
        }
      },

      (err) => {
       // console.error(err);
      }
    );
    }
    else
    {
      this.GetScreenNameList(this.ModuleID);
    }
  }

  GetApplicationIdsList(ModuleID: string) {
    this.subGetData = this.apiService.getData("api/IEGAuditActivityLogs/GetApplicationIdsList?ModuleName=" + this.ModuleID).subscribe(
      (res) => {
        if (res["Status"]) {
          this.ApplicationIdsList = res["Data"];
        } else {
          this.ApplicationIdsList = [];
        }
      },

      (err) => {
        //console.error(err);
      }
    );
  }

  addSuggestionList(event) {
    let AppId =event.target.value;
    let AppIds : any[] = [];//  this.AuditLogForm.controls['ApplicationID']?.value;
      if (AppId!=null && AppId!= "" && AppId!=undefined ) {
      if (AppIds == null || AppIds.length == 0)
      AppIds.push({ value: AppId, label: AppId });
      else {
        let fAppId = AppIds.find(x => x.label.toLowerCase() == AppId.toLowerCase());
        if (fAppId == null || fAppId == undefined)
        AppIds.push({ value: AppId, label: AppId });
      }
    }
  }

  filterApplicationId(event) {
    let filtered: any[] = []; let query = event.query;
    for (let i = 0; i < this.ApplicationIdsList.length; i++) {
      let ApplicationId = this.ApplicationIdsList[i];
      if (ApplicationId.label.toLowerCase().indexOf(query.toLowerCase()) == 0) { filtered.push(ApplicationId); }
    }
    this.filteredApplicationIds = filtered;
  }

  change(event) {
    let val = this.filteredApplicationIds?.find(x => x.label == event.value.label);
    if (val == null || val == undefined) {
      this.AuditLogForm.controls['ApplicationID'].setValue("");
    } else{
      this.AuditLogForm.controls['ApplicationID'].setValue(val.label);
    }
  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  Clear() {
    this.AuditLogForm.patchValue({
      ApplicationID: "",
      ScreenName: "",
      UserName: "",
      StartDate: null,
      EndDate: null,
      cComp: "",
      cDetails: "",
      GrantType: "All"
    });
    this.rowData = [];
    //this.SDates = "";
  //this.EDates = "";
  this.maxDate = new Date();
  }
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject={};
  Full_End_Date: DateObject={};
  endDateSelect(event){
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
    this.maxDate = new Date(event);
  }
  startDateSelect(event)
  {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
    this.minDate = new Date(event);
  }
  Search() {
    if (this.validateForm()) {
      this.auditLogSearch = new IEGAuditLogSearch();
      let Appdata = this.AuditLogForm.controls["ApplicationID"].value;
      var appId=(Appdata.label ==null || Appdata.label ==undefined)?Appdata:Appdata.label;
      this.auditLogSearch.ApplicationId = appId;
      this.auditLogSearch.ModuleId = this.ModuleID;
      this.auditLogSearch.GrantType = this.AuditLogForm.controls["GrantType"].value;
      this.auditLogSearch.ScreenName = this.AuditLogForm.controls["ScreenName"].value;
      this.auditLogSearch.UserName = this.AuditLogForm.controls["UserName"].value;
      this.auditLogSearch.StartDate = this.AuditLogForm.controls["StartDate"].value;
      this.auditLogSearch.EndDate = this.AuditLogForm.controls["EndDate"].value;
      this.auditLogSearch.EndDateO = this.Full_End_Date;
      this.auditLogSearch.StartDateO = this.Full_Start_Date;
      this.auditLogSearch.cDetails = "v";
      this.auditLogSearch.cComp = "p";
      this.clonedauditLogSearch = JSON.parse(JSON.stringify(this.auditLogSearch));
      this.auditLogSearch.ModuleId = this.clonedauditLogSearch.ModuleId;
      this.subSearchRecords = this.apiService.getDataPost("api/IEGAuditActivityLogs/GetIEGAuditLogDataForScreenSearch", this.auditLogSearch).subscribe(result => {
        if (result.Status && result.Data.length > 0) {

          this.rowData = result.Data;
        } else {
          this.rowData = [];
        }
      });
    }
  }

  validateForm() {
    var err: any = [];
    if (!this.AuditLogForm.valid) {
      if(this.screencode!="grants")
      {
      if (
        !this.AuditLogForm.controls["ScreenName"].value &&
        !this.AuditLogForm.controls["ApplicationID"].value &&
        !this.AuditLogForm.controls["UserName"].value &&
        !this.AuditLogForm.controls["StartDate"].value &&
        !this.AuditLogForm.controls["EndDate"].value
      ) {
        err.push("Provide at least one criteria to perform search");
        this.commonService.ValidationBanner(err);
        //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
        return false;
      }
    }
      if ((this.AuditLogForm.get('ApplicationID')?.value == null || this.AuditLogForm.get('ApplicationID')?.value == "")) {
        err.push("Please select application ID");
        this.commonService.ValidationBanner(err);
        //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
        return false;
      }
      if (
        !this.AuditLogForm.controls["UserName"]?.valid &&
        ((this.AuditLogForm.controls["StartDate"].value == null &&
        this.AuditLogForm.controls["EndDate"].value == null) ||
        (this.AuditLogForm.controls["StartDate"].value == "" &&
        this.AuditLogForm.controls["EndDate"].value == ""))
      ) {
        err.push("Please select username /date range");
        this.commonService.ValidationBanner(err);
        //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
        return false;
      }

      if (this.AuditLogForm.controls["StartDate"].value != null) {
        if (this.AuditLogForm.controls["EndDate"].value == null) {
          err.push("Please select end date");
          this.commonService.ValidationBanner(err);
          //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
          return false;
        }
      }
      if (this.AuditLogForm.controls["StartDate"].value == null) {
        if (this.AuditLogForm.controls["EndDate"].value != null) {
          err.push("Please select start date");
          this.commonService.ValidationBanner(err);
          //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
          return false;
        }
      }


      // if (
      //   this.AuditLogForm.controls["StartDate"].value != null && this.AuditLogForm.controls["EndDate"].value != null)
      //   {
      //   if (
      //     new Date(this.AuditLogForm.controls["StartDate"].value) >
      //     new Date(this.AuditLogForm.controls["EndDate"].value)
      //   ) {
      //     err.push("Start Date should not be greater than End Date");
      //     this.commonService.ValidationBanner(err);
      //     //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: err } } });
      //     return false;
      //   }
      // }
    }
    return true;
  }


  View(RecordData: any) {

    var VersionID = RecordData['VersionID'];
    var heading = RecordData['ApplicationCode'];
    var CategoryName = RecordData['ApplicationCode'];
    this.log_data = RecordData;
    this['self'].auditLogSearch = new IEGAuditLogSearch();
    let Appdata = this['self'].AuditLogForm.controls["ApplicationID"].value;
    this['self'].auditLogSearch.ApplicationId = Appdata.label;
    this['self'].auditLogSearch.ModuleId = this['self'].screencode;
    this['self'].auditLogSearch.GrantType =this['self'].AuditLogForm.controls["GrantType"].value;
    this['self'].auditLogSearch.ScreenName =this['self'].AuditLogForm.controls["ScreenName"].value;// this['self'].selectedRow['ScreenName']; //this['self'].AuditLogForm.controls["ScreenName"].value;
    this['self'].auditLogSearch.UserName = this['self'].AuditLogForm.controls["UserName"].value;
    this['self'].auditLogSearch.StartDate = this['self'].AuditLogForm.controls["StartDate"].value;
    this['self'].auditLogSearch.EndDate = this['self'].AuditLogForm.controls["EndDate"].value;
    this['self'].auditLogSearch.cDetails = "v";
    this['self'].auditLogSearch.cComp = "p";
    let modalRef1 = this['self'].modalService.open(PreviewAuditLogsComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true,

    });
    modalRef1.componentInstance.Content ={
      heading: heading,
      content: {
        VersionID: VersionID, category_name: CategoryName, log_data: this.log_data,
        IEGsearch: this['self'].auditLogSearch
      }
    }

  }
  onRowDoubleClicked(RecordData: any) {
    var VersionID = RecordData.data['VersionID'];
    var heading = RecordData.data['ApplicationCode'];
    var CategoryName = RecordData.data['ApplicationCode'];
    this.log_data = RecordData.data;
    this.auditLogSearch = new IEGAuditLogSearch();
    let Appdata = this.AuditLogForm.controls["ApplicationID"].value;
    this.auditLogSearch.ApplicationId = Appdata.label;
    this.auditLogSearch.ModuleId = this.screencode;
    this.auditLogSearch.GrantType =this.AuditLogForm.controls["GrantType"].value;
    this.auditLogSearch.ScreenName =this.AuditLogForm.controls["ScreenName"].value;// event.data['ScreenName']; //this['self'].AuditLogForm.controls["ScreenName"].value;
    this.auditLogSearch.UserName = this.AuditLogForm.controls["UserName"].value;
    this.auditLogSearch.StartDate = this.AuditLogForm.controls["StartDate"].value;
    this.auditLogSearch.EndDate = this.AuditLogForm.controls["EndDate"].value;
    this.auditLogSearch.cDetails = "v";
    this.auditLogSearch.cComp = "p";
    let modalRef1 = this.modalService.open(PreviewAuditLogsComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef1.componentInstance.Content={
      heading: heading,
      content: {
        VersionID: VersionID, category_name: CategoryName, log_data: this.log_data,
        IEGsearch: this.auditLogSearch
      }
    }
    }


}
export class IEGAuditLogSearch {
  ModuleId?: string;
  ApplicationId?: string;
  ScreenName?: string;
  UserName?: string;
  StartDate?: string;
  EndDate?: string;
  OrgID?: string;
  cDetails?: string;
  cComp?: string;
  GrantType?: string;
  StartDateO : DateObject;
  EndDateO:DateObject

}

export class IEGDLLData
{
    lstPros : Array<any> = [];
    GrantDropDownData : Array<any> = [];
}
